import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { URL_SERVICIOS } from '../config/config';
import { ErrorsService } from './errors.service';

@Injectable({
  providedIn: 'root'
})
export class MantenedorService {

  constructor(
    public http: HttpClient,
    public router: Router,
    public _errors: ErrorsService,
  ) {}

 

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getSpecialityList        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getSpecialityList() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postGetSpecialityList', JSON.stringify({}), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

  async getSubSpecialityList(id_spe) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    //console.log("Espe: "+id_spe);
    let params = {
      id_spe: id_spe 
    }

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postGetSubSpecialityList', JSON.stringify(params), httpOptions).toPromise()
      //console.log(data);
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

  async editSpe(datos_spe) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {

      id_spe: datos_spe.id_spe ,
      name_spe: datos_spe.name_spe 

    }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postUpdateSpeciality', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }



   }



  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getCountry       /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getCountry() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/getCountry', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////      Educational Institutions    ////////////////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getInstitution       /////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getInstitution() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/getInstitution', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       addInstitution       /////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async addInstitution(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      ins_name: data.ins_name,
      cou_id: data.cou_id,
     }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/addInstitution', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       editInstitution       ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async editInstitution(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      ins_id: data.ins_id,
      ins_name: data.ins_name,
      cou_id: data.cou_id,
     }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/editInstitution', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }


  ///////////////////////////////////////////////////////////      Isapres    ////////////////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getIsapre     /////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getIsapre() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postListarIsapres', JSON.stringify(params), httpOptions ).toPromise()
      return data // hea_ins_id as id_isapre, hea_ins_code, hea_ins_name as nombre_isapre
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       addIsapre      /////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async addIsapre(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      insCode: data.hea_ins_code,
      nombreIsapre: data.nombre_isapre,
     }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postCrearIsapre', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       editIsapre      ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async editIsapre(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      idIsapre: data.id_isapre,
      insCode: data.hea_ins_code,
      nombreIsapre: data.nombre_isapre,
     }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postModificarIsapre', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }


  ///////////////////////////////////////////////////////////      Diagnostics    ////////////////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getDiagnostic     /////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getDiagnostic (search_diagnostic) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { 
      search_diagnostic: search_diagnostic,
    }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/getDiagnostic', JSON.stringify(params), httpOptions ).toPromise()
      return data // dia_id, dia_cie10, dia_name
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       addDiagnostic     /////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async addDiagnostic(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
        dia_name: data.dia_name,
        dia_cie10: data.dia_cie10,
     }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/addDiagnostic', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       editDiagnostic    ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async editDiagnostic(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      dia_id: data.dia_id,
      dia_name: data.dia_name,
      dia_cie10: data.dia_cie10,
     }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/editDiagnostic', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ////////////////////////////////////////////////////////      Tips    /////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getInfoTips    ///////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getTips(conInfoType = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      'order_by': 'con_info_id',
      'con_info_type': conInfoType
     };
    try {
      let data = await this.http.post( URL_SERVICIOS + '/getInfoTips', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  async saveTips(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    
    let params = {
      'titulo': data.titulo,
      'descripcion': data.descripcion,
      'fechaFrom': data.fechaFrom,
      'fechaTo': data.fechaTo,
      'prioridad': data.numero,
      'coninfoType': data.con_info_type,
      'is_global': data.is_global,
      'client_id': data.client_id,
     };
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postSaveTips', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }
  
  async updateTips(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    
    let params = {
      'id': data.con_info_id,
      'titulo': data.con_info_title,
      'descripcion': data.con_info_description,
      'fechaFrom': data.con_info_date_from2,
      'fechaTo': data.con_info_date_to2,
      'prioridad': data.con_info_priority,
      'coninfoType': data.con_info_type,
      'status': data.status,
      'is_global': data.is_global,
      'client_id': data.con_info_cus_id,
     };

    try {
      let data = await this.http.post( URL_SERVICIOS + '/postUpdateTips', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }



  ////////////////////////////////////////////////////////      Agreements    /////////////////////////////////////////////////////


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getB2BAgreement    ///////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getB2BAgreement() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = [{}];
    try {
      let data = await this.http.post( URL_SERVICIOS + '/getDashB2BAgreement', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  /////////////////////////////////////////////////////////       postUpdateB2BAgreement    ///////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async postUpdateB2BAgreement(b2bAgreement, tipo){
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { b2bAgreement }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postDashCrudB2BAgreement/'+tipo, JSON.stringify(params), httpOptions ).toPromise()
      return data;
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////       getB2BAgreementType    //////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getB2BAgreementType() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {};
    try {
      let data = await this.http.post( URL_SERVICIOS + '/getDashB2BAgreementType', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  async postUpdateB2BAgreementType(b2bAgreementType){
    // console.log('(S) postUpdateB2BAgreementType');

    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { b2bAgreementType }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postDashUpdateB2BAgreementType', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  uploadB2BImage(id: number, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('image', file);


    return this.http.post(URL_SERVICIOS +'/postDashUpdateB2BAgreementImage/'+id, formData).toPromise();
  }

  getClientIvirtual() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {};
    try {
      let data = this.http.post( URL_SERVICIOS + '/getCustomerIVirtual', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  getConfigsIVirtual(id_customer) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { 
      'cus_id': id_customer
     };
    try {
      let data = this.http.post( URL_SERVICIOS + '/getConfigIvirtual', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  async postSaveConfigsIVirtual(datos) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postSaveConfigsIVirtual', JSON.stringify(datos), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  //** Sponsors login **/
  async postUpdateSponsorsCustomer(sponsor, tipo){
    // console.log('(S) postUpdateB2BAgreementType');

    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { sponsor }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postDashCrudSponsorCustomer/'+tipo, JSON.stringify(params), httpOptions ).toPromise()
      return data;
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  async uploadSponsorImage(id: number, file: File): Promise<any> {
    //console.log('uploadSponsorImage');
    const formData = new FormData();
    formData.append('image', file);
    return this.http.post(URL_SERVICIOS +'/postDashUpdateSponsorImage/'+id, formData).toPromise();
  }

  async getSponsorAds(){
    //console.log('(S) getSponsorAds');
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {};
    try {
      let data = await this.http.post( URL_SERVICIOS + '/getDashListSponsorCustomer', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }
  //** Sponsors login **/

  //** Certificaciones */
  async postUpdateCertificationsCustomer(cert, tipo){
    console.log('(S) postUpdateCertificationsCustomer');

    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = { cert }
    try {
      let data = await this.http.post( URL_SERVICIOS + '/postDashCrudCertificateCustomer/'+tipo, JSON.stringify(params), httpOptions ).toPromise()
      return data;
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  async uploadCertificationImage(id: number, file: File): Promise<any> {
    //console.log('uploadSponsorImage');
    const formData = new FormData();
    formData.append('image', file);
    return this.http.post(URL_SERVICIOS +'/postDashUpdateCertificateImage/'+id, formData).toPromise();
  }

  async getCertifications(){
    //console.log('(S) getCertifications');
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {};
    try {
      let data = await this.http.post( URL_SERVICIOS + '/getDashListCertificationsCustomer', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }
  //** Certificaciones */

}
